import classNames from 'classnames';

export interface CriticalElementRowSkeletonProps {
  nameWidthClass: string;
  metaWidthClass: string;
}

const SUMMARY_COLUMN_COUNT = 3;
const SUMMARY_COLUMNS = Array.from(
  { length: SUMMARY_COLUMN_COUNT },
  (_, index) => index
);

const CriticalElementRowSkeleton = ({
  nameWidthClass,
  metaWidthClass,
}: CriticalElementRowSkeletonProps) => (
  <div
    className="flex w-full items-center gap-3 rounded-[10px] border border-navy-200 px-4 py-3"
    data-testid="critical-element-row-skeleton"
  >
    <div className="size-3 shrink-0 rounded bg-gray-200" />

    <div className="flex min-w-0 flex-1 flex-col gap-1.5">
      <div
        className={classNames(
          'h-5 max-w-full rounded bg-gray-200',
          nameWidthClass
        )}
      />
      <div
        className={classNames(
          'h-4 max-w-full rounded bg-gray-100',
          metaWidthClass
        )}
      />
    </div>

    <div className="flex shrink-0 items-center gap-4">
      {SUMMARY_COLUMNS.map((column) => (
        <div key={column} className="flex flex-col items-end gap-1">
          <div className="h-3 w-8 rounded bg-gray-100" />
          <div className="h-4 w-12 rounded bg-gray-200" />
          <div className="h-3 w-14 rounded bg-gray-100" />
        </div>
      ))}
    </div>
  </div>
);

export default CriticalElementRowSkeleton;
